import React from "react";
import EnquiryForm from "@/components/EnquiryForm";

const INDUSTRIES = [
  { title: "Logistics & Transport", desc: "Live fleet visibility, ETA management, fuel monitoring and driver scoring for transport companies.", img: "https://images.unsplash.com/photo-1592838064575-70ed626d3a0e?w=1200&q=80" },
  { title: "School Buses", desc: "Parent live-tracking app, pickup / drop alerts, RFID attendance and rash-driving reports for schools.", img: "https://images.unsplash.com/photo-1608889825205-eebdb9fc5806?w=1200&q=80" },
  { title: "Delivery & Last-Mile", desc: "Rider tracking, delivery route optimisation and battery-aware devices for e-commerce and food delivery.", img: "https://images.unsplash.com/photo-1568772585407-9361f9bf3a87?w=1200&q=80" },
  { title: "Corporate Fleets", desc: "Executive vehicle tracking, geofences for offices, and consolidated fleet reports for HR & admin.", img: "https://images.unsplash.com/photo-1580982327559-c1202864eb05?w=1200&q=80" },
  { title: "Personal Vehicles", desc: "Anti-theft, family-share tracking and driving insights for cars and two-wheelers.", img: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=1200&q=80" },
  { title: "Construction & Heavy", desc: "Rugged devices for trucks, tankers and refrigerated fleets with fuel & temperature sensors.", img: "https://images.unsplash.com/photo-1591489378430-ef2f4c626b35?w=1200&q=80" },
];

export default function Industries() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-testid="industries-page">
      <div className="max-w-3xl">
        <div className="eyebrow">Industries we serve</div>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold text-[#0A192F] mt-3">GPS solutions tailored to your business</h1>
      </div>
      <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-6">
        {INDUSTRIES.map((it) => (
          <div key={it.title} className="rounded-2xl overflow-hidden border border-slate-200 bg-white flex flex-col lg:flex-row">
            <img src={it.img} alt={it.title} className="w-full lg:w-2/5 h-52 lg:h-auto object-cover" />
            <div className="p-6 flex-1">
              <h3 className="font-heading text-xl font-bold text-[#0A192F]">{it.title}</h3>
              <p className="text-sm text-slate-600 mt-3">{it.desc}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-16">
        <EnquiryForm title="Discuss your industry requirement" subtitle="Fleet, school bus, delivery or personal — our team will craft the right plan." testIdPrefix="industries-enquiry" />
      </div>
    </div>
  );
}
